/*
 * HomePage
 */

import React from 'react';

// Material Resources
import { useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import getClientMode from '../../../store/utils-store/selectors';

// Components & Others
// import Documents from '../../../components/Documents';
import Documents from '../../../components/Models/Documents/documents';

// Styles & Images

function DocumentsPage() {
  return (
    <Grid container alignItems="start">
      <Grid item xs={12}>
        <Documents />
      </Grid>
    </Grid>
  );
}

export default DocumentsPage;
